import { Ref, forwardRef, useImperativeHandle, useState } from "react";
import { WalletRead, MyWalletService, WalletTransfer } from "@/domains/wallet";
// components
import { Button, Form, Input, Modal } from "antd";

interface TransferModalProps {
  onTransfer: () => void;
}

export interface TransferModalRef {
  open: (wallet: WalletRead) => void;
}

export const TransferModal = forwardRef(
  ({ onTransfer }: TransferModalProps, ref: Ref<TransferModalRef>) => {
    const [showing, setShowing] = useState(false);

    const [wallet, setWallet] = useState<WalletRead>();

    const [form] = Form.useForm<WalletTransfer>();

    const handleConfirm = async () => {
      if (!wallet) return;

      const formValue = await form.validateFields();

      try {
        await MyWalletService.transfer(wallet.id, formValue).run();
        setShowing(false);
        onTransfer();
      } catch (e) {
        console.log(e);
      }
    };

    const handleCancel = () => {
      setShowing(false);
    };

    useImperativeHandle(
      ref,
      () => {
        const open = (_wallet: any) => {
          form.resetFields();

          form.setFieldsValue({
            amount: "",
            address: "",
            note: "",
          });

          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          setWallet(_wallet);

          setShowing(true);
        };

        return { open };
      },
      [form]
    );

    return (
      <Modal
        title="轉帳"
        open={showing}
        footer={[
          <div className="flex jc:end gap:8" key="footer">
            <Button key="back" onClick={handleCancel}>
              取消
            </Button>
            <Button key="submit" type="primary" onClick={handleConfirm}>
              送出
            </Button>
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Form className="mt:16" form={form} labelCol={{ span: 6 }}>
          <Form.Item
            label="轉帳金額"
            name="amount"
            rules={[{ required: true, message: "轉帳金額不可空白" }]}
          >
            <Input type="number" placeholder="請輸入轉帳金額" />
          </Form.Item>

          <Form.Item
            label="收款地址"
            name="address"
            rules={[{ message: "收款地址不可空白" }]}
          >
            <Input placeholder="請輸入收款地址" />
          </Form.Item>

          <Form.Item label="備註" name="note">
            <Input placeholder="請輸入轉帳備註" />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
);
